var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearch = function SvgSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4249 1.24805C5.35776 1.24805 1.25 5.35581 1.25 10.423C1.25 15.4902 5.35776 19.5979 10.4249 19.5979C12.73 19.5979 14.8365 18.7479 16.4481 17.3442L21.4636 22.523C21.7517 22.8205 22.2266 22.8281 22.5241 22.54C22.8216 22.2518 22.8293 21.777 22.5411 21.4795L17.4958 16.2699C18.81 14.6824 19.5999 12.6449 19.5999 10.423C19.5999 5.35581 15.4921 1.24805 10.4249 1.24805ZM2.75 10.423C2.75 6.18423 6.18619 2.74805 10.4249 2.74805C14.6637 2.74805 18.0999 6.18423 18.0999 10.423C18.0999 14.6617 14.6637 18.0979 10.4249 18.0979C6.18619 18.0979 2.75 14.6617 2.75 10.423Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "search.f1473b7406ae9b49cb22b6198b211499.svg";